/**
 *  Parses options to an array of strings in use-cases where the component is used as a web-component by a consumer
 *  This is because an array will be converted to a comma-seperated string when used as a web-component
 *  When used as a Stencil component by another anchor component it will however be an array of strings
 *  Is called before the initial render
 */
export const parseTypeaheadOptions = (options: any) => {
  if (!options) {
    return [];
  }
  if (typeof options === 'object') {
    return options;
  }
  try {
    const parsedOptions = JSON.parse(options);
    if (Array.isArray(parsedOptions) && typeof parsedOptions[0] === 'string') {
      return parsedOptions.map(option => ({ label: option, value: option }));
    }
    return parsedOptions;
  } catch (e) {
    return options;
  }
};
